//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from "~/api/api";
import isMobile from "~/mixins/isMobile.js";
import Plan from "@/models/Plan";
import aos from "~/mixins/aos.js";

export default {
  mixins: [isMobile, aos],
  data() {
    return { plansLoaded: false };
  },
  head() {
    if (this.pageInfo && this.metaInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain + "/pricing";
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },
  asyncData({ app, query, params, redirect, error }) {
    return Promise.all([
      API.butterPages.get(app.$axios, "pricing", {
        preview: query.preview ? 1 : 0,
      }),
    ])
      .then((results) => {
        const pageInfo = results[0];

        return {
          pageInfo,
          loading: false,
          error: false,
        };
      })
      .catch((e) => {
        console.error(e);
        error({ message: "Error fetching data..." });

        return {
          loading: false,
        };
      });
  },
  computed: {
    hero() {
      return this.pageInfo.fields.hero.table;
    },
    plus() {
      return this.pageInfo.fields.plus.table;
    },
    single_doc() {
      return this.pageInfo.fields.single_doc.table;
    },
    moneyback() {
      return this.pageInfo.fields.moneyback;
    },
    get_started() {
      return this.pageInfo.fields.get_started.table;
    },
    business_services() {
      if (this.pageInfo.fields.business_services)
        return this.pageInfo.fields.business_services.table;
      else return false;
    },
    ep() {
      if (this.pageInfo.fields.ep) return this.pageInfo.fields.ep.table;
      else return false;
    },
    metaInfo() {
      if (this.pageInfo.fields.meta_information)
        return this.pageInfo.fields.meta_information.table;
      return false;
    },
    services() {
      if (this.business_services || this.ep) return true;
      else return false;
    },
    currency() {
      return "$";
    },
    plans() {
      return this.$store
        .$db()
        .model("plans")
        .query()
        .first();
    },
    annualPlan() {
      if (this.plans && this.plans.annual_plan)
        return {
          ...this.plans.annual_plan,
          dollars: (this.plans.annual_plan.price_cents / 100).toFixed(),
          cents: this.plans.annual_plan.price_cents
            .toString()
            .substring(
              this.plans.annual_plan.price_cents.toString().length - 2
            ),
          monthly_price: (this.plans.annual_plan.price_cents / 1200).toFixed(2),
        };
    },
    monthlyPlan() {
      if (this.plans && this.plans.monthly_plan)
        return {
          ...this.plans.monthly_plan,
          dollars: this.plans.monthly_plan.price_cents
            .toString()
            .substring(0, 2),
          cents: this.plans.monthly_plan.price_cents.toString().substring(2, 4),
        };
    },
  },
  created() {
    Plan.fetchAll().then((_) => {
      this.plansLoaded = true;
    });
  },
};
